import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalFilterService } from '../../services/global-filter.service';

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss'],
})
export class YearPickerComponent implements OnInit, OnDestroy {
  @Output() yearsSelected = new EventEmitter<{ year1; year2 }>();
  @Input() startYear;
  @Input() endYear;
  selectedStartYear: any;
  selectedEndYear: any;
  selectedYears: number[] = [];
  showCalendar: boolean = false;
  years: any[] = [];
  private subs = new Subscription();
  private updated = false;

  constructor(private el: ElementRef, private globalFilterService: GlobalFilterService) {}

  ngOnInit() {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((value: any) => {
        if (value && value?.start_year && value?.end_year) {
          this.selectedYears = [];
          this.selectedYears.push(value.start_year);
          this.selectedYears.push(value.end_year);
          this.selectedStartYear = this.selectedYears[0];
          this.selectedEndYear = this.selectedYears[1];
        } else if (value && value?.start_year) {
          this.selectedYears = [];
          this.selectedYears.push(value.start_year);
          this.selectedStartYear = this.selectedYears[0];
        } else if (value && value?.start_year === null && value?.end_year === null) {
          this.selectedYears = [];
          this.selectedStartYear = null;
          this.selectedEndYear = null;
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    this.years = [];
    for (let i = this.startYear; i <= this.endYear; i++) {
      this.years.push(i);
    }
    // this.selectedStartYear = this.years[0];
    // this.selectedEndYear = this.years[this.years.length - 1];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  isYearSelected(year: number): boolean {
    return this.selectedYears.includes(year);
  }

  displayTimeFrame() {
    let displayTimeFrameDate;
    if (this.selectedYears.length == 1) {
      displayTimeFrameDate = this.selectedYears[0];
    } else {
      displayTimeFrameDate = this.selectedYears[0] + '-' + this.selectedYears[this.selectedYears.length - 1];
    }
    return displayTimeFrameDate;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const isClicked = this.el.nativeElement.contains(event.target);
    if (!isClicked) {
      this.showCalendar = isClicked;
    }
    if (!this.showCalendar && this.updated) {
      this.yearsSelected.emit({ year1: this.selectedStartYear, year2: this.selectedEndYear });
      this.updated = false;
    }
  }

  selectYear(yearType: string, year: any) {
    if (yearType == 'selectedStartYear') {
      if (year <= this.selectedEndYear) {
        this.selectedStartYear = year;
        this.updated = true;
      }
    } else if (yearType == 'selectedEndYear') {
      if (year >= this.selectedStartYear) {
        this.selectedEndYear = year;
        this.updated = true;
      }
    }
  }
}
